module.exports = __webpack_public_path__ + "static/media/manhua.5b0e4d54.png";